import { ExtensionTopicJoinApplyStatusEnum } from "../SuperEnum";
import Tools from "../Tools";
import ad_account from "../vo/dbvo/ad_account";
import ad_extension from "../vo/dbvo/ad_extension";
import ad_extension_topic_join_apply from "../vo/dbvo/ad_extension_topic_join_apply";
import ad_template from "../vo/dbvo/ad_template";
import ad_topic from "../vo/dbvo/ad_topic";

export type InputCreateExtensionAdvertisement = {
    /**
     * 广告唯一标识符
     */
    AdUniqueIdentifier?: string;
    /**
     * 模板唯一标识
     */
    TempUniqueIdentifier?: string;
    /**
     * 缩略图
     */
    Thumbnail?: File;
    /**
     * 缩略图URL
     */
    ThumbnailURL?: string;
    /**
     * 推广名称
     */
    ExtensionName: string;
    /**
     * 打赏总额
     */
    RewardAmount: number;
    /**
     * 每秒结算额度不能为空
     */
    PricePerSecond: number;
    /**
     * 广告生效开始日期(空则为不限制)
     */
    AdStartDate?: string;
    /**
     * 广告生效结束日期(空则为不限制)
     */
    AdOverDate?: string;
    /**
     * 生效开始时间段(空则为不限制)
     */
    LimitStartTime?: string;
    /**
     * 生效结束时间段(空则为不限制)
     */
    LimitEndTime?: string;
};

export type InputUpdateExtensionAdvertisement = {
    ExtensionUniqueIdentifier: string;
    ExtensionName: string;
    /**
     * 缩略图
     */
    Thumbnail?: File;
    /**
     * 缩略图URL，如上面File是空的，它生效
     */
    ThumbnailURL?: string;
    AdStartDate?: string;
    AdOverDate?: string;
    LimitStartTime?: string;
    LimitEndTime?: string
};

export type InputExtensionTopicJoinApply = {
    /**
     * 推广唯一标识
     */
    ExtensionUniqueIdentifier: string;
    /**
     * 主题唯一标识
     */
    TopicUniqueIdentifier: string;
};

export type InputExtensionJoinTopicAudit = {
    ExtensionUniqueIdentifier: string;
    AuditStatus: ExtensionTopicJoinApplyStatusEnum,
    Remarks?: string;
}

export enum JoinApplyFilterEnum {
    /**
     * 我的申请
     */
    MyApply = 1,
    /**
     * 待审核
     */
    WaitAudit = 2,
    /**
     * 已审核
     */
    AlreadyAudit = 3,
    /**
     * 已拒绝
     */
    Refuse = 4
}

export type InputGetExtensionShopList = {
    Page: number,
    PageSize: number,
    Filter?: InputGetExtensionShopListFilter
}

/**
 * 输入筛选模式
 */
export type InputGetExtensionShopListFilter = {
    /**
     * 筛选推广广告名称
     */
    ExtensionName?: string;
    /**
     * 根据总打赏金额排序
     * DESC 或 ASC
     */
    OrderByTotalRewardAmount?: "DESC" | "ASC";
    /**
     * 根据每秒价格排序
     * DESC 或 ASC
     */
    OrderByPricePerSecond?: "DESC" | "ASC"
}

/**
 * 导入广告主题
 */
export type InputImportAdToTopic = {
    /**
     * 推广广告的唯一标识符
     */
    extension_unique_identifier: string;
    /**
     * 要绑定的主题列表
     */
    to_topic_unique_identifiers: string[]
};

/**
 * 推广相关
 */
export default class ExtensionApi {
    /**
     * 创建推广广告
     * @param input 
     * @returns 
     */
    public CreateExtensionAdvertisementAsync(input: InputCreateExtensionAdvertisement) {
        return Tools.FetchAsync("Extension/CreateExtensionAdvertisement", input, "POST", "multipart/form-data");
    }

    /**
     * 修改推广广告数据
     * @param input 
     */
    public UpdateExtensionAdvertisementAsync(input: InputUpdateExtensionAdvertisement) {
        return Tools.FetchAsync("Extension/UpdateExtensionAdvertisement", input, "PATCH", "multipart/form-data");
    }

    /**
     * 导入推广广告主题
     */
    public ImportAdToTopicAsync(input: InputImportAdToTopic) {
        return Tools.FetchAsync("Extension/ImportAdToTopic", input, "POST");
    }

    /**
     * 获取我的推广数据列表
     */
    public GetMyExtensionAdvertisementAsync(page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_extension[]
        }>("Extension/GetMyExtensionAdvertisement", {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 推广广告加入主题申请
     * @param input 
     */
    public ExtensionTopicJoinApplyAsync(input: InputExtensionTopicJoinApply) {
        return Tools.FetchAsync<{
            IsAudit?: boolean
        }>("Extension/ExtensionTopicJoinApply", input, "POST");
    }

    /**
     * 推广广告加入主题审核
     */
    public ExtensionJoinTopicAuditAsync(input: InputExtensionJoinTopicAudit) {
        return Tools.FetchAsync("Extension/ExtensionJoinTopicAudit", input, "POST");
    }


    /**s
     * 获取推广广告加入主题申请列表
     * @param page 当前页
     * @param pageSize 每页个数
     * @param filter 筛选条件
     * @returns 
     */
    public GetExtensioTopicJoinApplyAsync(page: number, pageSize: number, filter: JoinApplyFilterEnum) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: {
                apply_user: ad_account,
                ad_topic: ad_topic,
                ad_extension: ad_extension,
                ad_extension_topic_join_apply: ad_extension_topic_join_apply
            }[]
        }>("Extension/GetExtensioTopicJoinApply", {
            page,
            pageSize,
            filter
        }, "GET");
    }

    /**
     * 获取推广广告商店数据列表
     * @param page 
     * @param pageSize 
     */
    public GetExtensionShopListAsync(input: InputGetExtensionShopList) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: {
                extension: ad_extension,
                template: ad_template,
                isImport: boolean,
                spreadCount: number
            }[]
        }>("Extension/GetExtensionShopList", input, "POST");
    }
}